import { PictureFormatsStateInterface } from "../actions/picture-formats.actions";

export const PICTURE_FORMATS_STATE: PictureFormatsStateInterface = {
  types: {
    type_4k: {
      format_16_9: { width: 3840, height: 2160 },
      format_4_3: { width: 2880, height: 2160 },
      format_3_4: { width: 1620, height: 2160 },
      format_7_15: { width: 1008, height: 2160 },
      format_10_3: { width: 3840, height: 1152 },
      format_1_1: { width: 2160, height: 2160 },
      format_2_3: { width: 1440, height: 2160 },
      format_3_1: { width: 3840, height: 1280 },
      format_140_303: { width: 3360, height: 7272 },
      format_216_65: { width: 8640, height: 2600 },
      format_485_173: { width: 3880, height: 1384 },   
    },
    type_hd: {
      format_16_9: { width: 1920, height: 1080 },
      format_4_3: { width: 1440, height: 1080 },
      format_3_4: { width: 810, height: 1080 },
      format_7_15: { width: 504, height: 1080 },
      format_10_3: { width: 1920, height: 576 },
      format_1_1: { width: 1080, height: 1080 },
      format_2_3: { width: 720, height: 1080 },
      format_3_1: { width: 1920, height: 640 },
      format_140_303: { width: 1680, height: 3636 },
      format_216_65: { width: 4320, height: 1300 },
      format_485_173: { width: 1940, height: 692 },  
    },
  },
};

export function pictureFormatsReducer(
  state: PictureFormatsStateInterface = PICTURE_FORMATS_STATE,
  action
) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/picture-formats.reducer.ts